import { render, staticRenderFns } from "./listLotteryHistory.vue?vue&type=template&id=12f7f68a"
import script from "./listLotteryHistory.vue?vue&type=script&lang=js"
export * from "./listLotteryHistory.vue?vue&type=script&lang=js"
import style0 from "./listLotteryHistory.vue?vue&type=style&index=0&id=12f7f68a&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports